import { render, staticRenderFns } from "./packingListQuery_Component.vue?vue&type=template&id=0cb51a07&scoped=true&"
import script from "./packingListQuery_Component.vue?vue&type=script&lang=js&"
export * from "./packingListQuery_Component.vue?vue&type=script&lang=js&"
import style0 from "./packingListQuery_Component.vue?vue&type=style&index=0&id=0cb51a07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb51a07",
  null
  
)

export default component.exports